/* AYUSHU100 theme — small, dependency-free behaviours */
(function () {
  'use strict';

  // ---------- Mobile menu drawer ----------
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-drawer-open'));
      if (d) { d.classList.add('is-open'); open.setAttribute('aria-expanded', 'true'); var f = d.querySelector('a,button'); if (f) f.focus(); }
    }
    if (close) {
      var dr = close.closest('.drawer');
      if (dr) dr.classList.remove('is-open');
      document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
  });

  // ---------- Collection filters toggle (mobile) + auto-submit ----------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-filter-toggle]');
    if (!t) return;
    var s = document.getElementById(t.getAttribute('aria-controls'));
    if (!s) return;
    var isOpen = s.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(isOpen));
  });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches('[data-autosubmit]') || el.closest('form[data-filter-form]') && el.type === 'checkbox') {
      var form = el.form || el.closest('form');
      if (form) form.submit();
    }
  });

  // ---------- Quantity steppers ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(parseInt(input.min || '1', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- Product gallery ----------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var gallery = t.closest('.gallery');
    var main = gallery.querySelector('.gallery__main img');
    main.src = t.getAttribute('data-src');
    main.srcset = t.getAttribute('data-srcset') || '';
    main.alt = t.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
    t.setAttribute('aria-current', 'true');
  });

  // ---------- Toast ----------
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('CartToast');
    if (!el) return;
    el.querySelector('.toast__text').textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function setCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
  }

  // ---------- AJAX add to cart (progressive enhancement over <form action="/cart/add">) ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-product-form]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var body = new FormData(form);
    fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add');
        toast('Added to cart: ' + (res.j.product_title || ''));
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  // ---------- Cart page: quantity change auto-updates ----------
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var form = input.form;
    clearTimeout(input._t);
    input._t = setTimeout(function () { form.submit(); }, 450);
  });
})();

// ---------- Mega menu (hover intent + click/keyboard) ----------
(function () {
  var items = document.querySelectorAll('[data-mega-item]');
  if (!items.length) return;
  var timer;
  function closeAll(except) { items.forEach(function (i) { if (i !== except) { i.classList.remove('is-open'); var a = i.querySelector('[data-mega-top]'); if (a) a.setAttribute('aria-expanded', 'false'); } }); }
  function open(i) { closeAll(i); i.classList.add('is-open'); var a = i.querySelector('[data-mega-top]'); if (a) a.setAttribute('aria-expanded', 'true'); }
  var hover = window.matchMedia('(hover: hover)').matches;
  items.forEach(function (i) {
    var top = i.querySelector('[data-mega-top]');
    if (hover) {
      i.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { open(i); }, document.querySelector('[data-mega-item].is-open') ? 0 : 120); });
      i.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { i.classList.remove('is-open'); top.setAttribute('aria-expanded', 'false'); }, 180); });
    }
    top.addEventListener('click', function (e) {
      if (i.classList.contains('is-open') && top.getAttribute('href') !== '#') return; // second tap follows link
      if (!hover || top.getAttribute('href') === '#') { e.preventDefault(); if (i.classList.contains('is-open')) closeAll(); else open(i); }
    });
    top.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(i); var f = i.querySelector('.mega__panel a'); if (f) f.focus(); }
    });
    i.addEventListener('focusout', function (e) { if (!i.contains(e.relatedTarget)) { i.classList.remove('is-open'); top.setAttribute('aria-expanded', 'false'); } });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var o = document.querySelector('[data-mega-item].is-open'); closeAll(); if (o) o.querySelector('[data-mega-top]').focus(); } });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-mega-item]')) closeAll(); });
})();
